import React, { useState } from "react";
import "../styles/LiveClass.css";
import axiosInstance from "../api/axiosInterceptor.js"; 
import SyncLoader from "../components/Loader";

const LiveClass = () => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    start_time: "",
    end_time: "",
    meeting_url: "",
  });

  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false); 

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      await axiosInstance.post("admin/calendar/", formData);
      setShowAlert(true);
      setFormData({
        title: "",
        description: "",
        start_time: "",
        end_time: "",
        meeting_url: "",
      });
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.detail || "Failed to schedule live class.");
    }
    finally {
      setIsLoading(false); // Stop the loader
    }
  };

  return (
    <>
      {isLoading && <SyncLoader />}
      {showAlert && <div className="success">✅ Live Class Scheduled Successfully!</div>}
      {error && <div className="error">❌ {error}</div>}

      <form className="liveclass-form" onSubmit={handleSubmit}>
        <h2>Schedule Live Class</h2>

        <label>Title</label>
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          required
        />

        <label>Description</label>
        <input
          type="text"
          name="description"
          value={formData.description}
          onChange={handleChange}
          required
        />

        <label>Start Date and Time</label>
        <input
          type="datetime-local"
          name="start_time"
          value={formData.start_time}
          onChange={handleChange}
          required
        />

        <label>End Date and Time</label>
        <input
          type="datetime-local"
          name="end_time"
          value={formData.end_time}
          onChange={handleChange}
          required
        />

        <label>Meeting URL</label>
        <input
          type="url"
          name="meeting_url"
          value={formData.meeting_url}
          onChange={handleChange}
          required
        />

        <button type="submit" className="submit-btn">Submit</button>
      </form>
    </>
  );
};

export default LiveClass;
